// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientIntakeRequestModel {
    static getAttributeTypeMap() {
        return PatientIntakeRequestModel.attributeTypeMap;
    }
}
PatientIntakeRequestModel.discriminator = undefined;
PatientIntakeRequestModel.additionalProperties = false;
PatientIntakeRequestModel.attributeTypeMap = [
    {
        "name": "patientAccountUpsearch",
        "baseName": "patientAccountUpsearch",
        "type": "EnterpriseCoordinatorAccountUpsearchRequestModel"
    },
    {
        "name": "closeIntake",
        "baseName": "closeIntake",
        "type": "boolean"
    },
];
//# sourceMappingURL=patientIntakeRequestModel.js.map